import axios from 'axios';

const resolveBaseURL = () => {
  try {
    const { hostname } = window.location;
    if (hostname.includes('localhost')) {
      return 'https://adminrotary.codiatest.com/';
    }
    return window.location.origin;
  } catch (e) {
    return 'https://adminrotary.codiatest.com/';
  }
};

export const httpClientGalleries = axios.create({
  baseURL: resolveBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain',
  },
  withCredentials: true,
});

httpClientGalleries.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth.token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

httpClientGalleries.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export const resolveGalleryAssetUrl = (path) => {
  if (!path || typeof path !== 'string') return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = resolveBaseURL().replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  // Backend galeri görsellerini /AllGalleries/... olarak döndürüyor.
  // Gerçek erişim: /api/galleries/AllGalleries/...
  if (normalizedPath.startsWith('/api/galleries/')) {
    return `${base}${normalizedPath}`;
  }

  return `${base}/api/galleries${normalizedPath}`;
};

export default httpClientGalleries;

